import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () =>
      import('@/app/login/login.module').then((module) => module.LoginModule),
  },
  {
    path: 'mfa/generate-code',
    loadChildren: () =>
      import('@/app/generate-code/generate-code.module').then(
        (module) => module.GenerateCodeModule
      ),
    canActivate: [authGuard]
  },
  {
		path: '**',
		redirectTo: 'mfa/generate-code',
		pathMatch: 'full',
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
